import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import { forwardRef, useState, useId, useCallback, createElement } from "react";
import { TextButton, IconButton } from "@creditornot/cb-button";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { createCssVars, pxToRem, clsx, assignInlineCssVars } from "@creditornot/cb-utils";
import "./style.css";
const SvgAlertDiamond = (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "m23 10.588-9.586-9.586a2 2 0 0 0-2.828 0L1 10.589a2 2 0 0 0 0 2.828l9.586 9.585a2 2 0 0 0 2.828 0L23 13.417a2 2 0 0 0 0-2.83Zm-11.932-4.17a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6Zm1.051 11.51h-.028a1.53 1.53 0 0 1-1.522-1.47 1.476 1.476 0 0 1 1.448-1.53h.028a1.527 1.527 0 0 1 1.522 1.47 1.477 1.477 0 0 1-1.448 1.53Z" }) });
const ForwardRef$1 = forwardRef(SvgAlertDiamond);
const SvgAlertTriangle = (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "m23.119 20.002-9.347-17.85a2 2 0 0 0-3.543 0L.881 20.002a2 2 0 0 0 1.772 2.928h18.694a2 2 0 0 0 1.772-2.928ZM11 8.425a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0v-6Zm1.05 11.51h-.028a1.528 1.528 0 0 1-1.522-1.47 1.476 1.476 0 0 1 1.448-1.53h.028a1.527 1.527 0 0 1 1.524 1.467 1.474 1.474 0 0 1-1.45 1.533Z" }) });
const ForwardRef = forwardRef(SvgAlertTriangle);
const CheckmarkCircleFilled = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12C0 5.373 5.373 0 12 0c6.624.008 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm17.552-5.78a1.25 1.25 0 011.197 1.977l-6.7 9.087a1.263 1.263 0 01-1.787.235l-4.783-3.826a1.251 1.251 0 011.563-1.953l3.767 3.014 5.924-8.04c.196-.267.49-.445.819-.495z"
    }
  ) })
);
const SvgCross = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M2.44 19.44a1.5 1.5 0 002.121 2.121l7.262-7.26a.25.25 0 01.354 0l7.262 7.262a1.5 1.5 0 102.122-2.12l-7.26-7.266a.25.25 0 010-.354l7.262-7.262a1.5 1.5 0 00-2.124-2.12L12.177 9.7a.25.25 0 01-.354 0L4.561 2.44A1.5 1.5 0 002.44 4.56L9.7 11.823a.25.25 0 010 .354L2.44 19.44z" }) }));
const SvgInfocircle = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12 0c6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.52-.006 9.994-4.48 10-10 0-5.523-4.477-10-10-10zm-.5 7.5a2 2 0 012 2v4.75c0 .138.112.25.25.25h.75a1 1 0 010 2h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1zm.75-4.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z" }) }));
const styleParamsCssVars = createCssVars(["padding", "fontSize"]);
const internalCssVars = createCssVars(["lineHeight", "iconSize", "closeButtonSize"]);
const sizeConfigs = {
  small: {
    padding: "8px",
    fontSize: pxToRem(12)
  },
  medium: {
    padding: "16px",
    fontSize: pxToRem(14)
  }
};
const iconClass = "cb_Alert_iconClass_igtq";
const icons = {
  error: ForwardRef$1,
  info: SvgInfocircle,
  success: CheckmarkCircleFilled,
  warning: ForwardRef
};
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Alert_Root_r1ji",
  propsAsIs: false
});
const Col = /* @__PURE__ */ styled("div")({
  name: "Col",
  class: "cb_Alert_Col_chkh",
  propsAsIs: false
});
const _exp11 = () => Col;
const LeftCol = /* @__PURE__ */ styled(_exp11())({
  name: "LeftCol",
  class: "cb_Alert_LeftCol_l1p9",
  propsAsIs: true
});
const _exp13 = () => Col;
const RightCol = /* @__PURE__ */ styled(_exp13())({
  name: "RightCol",
  class: "cb_Alert_RightCol_rxi3",
  propsAsIs: true
});
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_Alert_IconContainer_i12y",
  propsAsIs: false
});
const TitleRow = /* @__PURE__ */ styled("div")({
  name: "TitleRow",
  class: "cb_Alert_TitleRow_t1kh",
  propsAsIs: false
});
const TitleContainer = /* @__PURE__ */ styled("div")({
  name: "TitleContainer",
  class: "cb_Alert_TitleContainer_typ8",
  propsAsIs: false
});
const Title = /* @__PURE__ */ styled("div")({
  name: "Title",
  class: "cb_Alert_Title_t1fh",
  propsAsIs: false
});
const TitleContent = /* @__PURE__ */ styled("div")({
  name: "TitleContent",
  class: "cb_Alert_TitleContent_t165",
  propsAsIs: false
});
const TitleColumn = /* @__PURE__ */ styled("div")({
  name: "TitleColumn",
  class: "cb_Alert_TitleColumn_t130",
  propsAsIs: false
});
const CloseButtonContainer = /* @__PURE__ */ styled("div")({
  name: "CloseButtonContainer",
  class: "cb_Alert_CloseButtonContainer_c1hy",
  propsAsIs: false
});
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_Alert_Content_cui7",
  propsAsIs: false
});
const ShowMoreContent = /* @__PURE__ */ styled("div")({
  name: "ShowMoreContent",
  class: "cb_Alert_ShowMoreContent_sahj",
  propsAsIs: false
});
const Collapse = /* @__PURE__ */ styled("div")({
  name: "Collapse",
  class: "cb_Alert_Collapse_c1j4",
  propsAsIs: false
});
const ShowMoreInner = /* @__PURE__ */ styled("div")({
  name: "ShowMoreInner",
  class: "cb_Alert_ShowMoreInner_s6wc",
  propsAsIs: false
});
const Alert = ({
  children,
  className,
  closeButtonProps,
  initiallyOpen = false,
  onCloseButtonClick,
  showMoreContent,
  size = "medium",
  style,
  styleParams,
  title,
  titleRightContent,
  variant = "info",
  ...rest
}) => {
  const [open, setOpen] = useState(initiallyOpen);
  const collapsedContentId = useId();
  const handleShowMoreButtonClick = useCallback(() => setOpen((value) => !value), []);
  return /* @__PURE__ */ jsxs(Root, {
    className: clsx(className, typographyClassName.bodyBase),
    "data-variant": variant,
    role: "alert",
    style: {
      ...style,
      ...assignInlineCssVars(styleParamsCssVars, {
        ...sizeConfigs[size],
        ...styleParams
      })
    },
    ...rest,
    children: [/* @__PURE__ */ jsx(LeftCol, {
      children: /* @__PURE__ */ jsx(IconContainer, {
        children: createElement(icons[variant], {
          className: iconClass
        })
      })
    }), /* @__PURE__ */ jsxs(RightCol, {
      children: [/* @__PURE__ */ jsxs(TitleRow, {
        children: [/* @__PURE__ */ jsx(TitleContainer, {
          children: title ? /* @__PURE__ */ jsx(Title, {
            title,
            children: title
          }) : /* @__PURE__ */ jsx(TitleContent, {
            children
          })
        }), !!titleRightContent && /* @__PURE__ */ jsx(TitleColumn, {
          children: titleRightContent
        }), !!showMoreContent && /* @__PURE__ */ jsx(TitleColumn, {
          children: /* @__PURE__ */ jsx(TextButton, {
            "aria-controls": collapsedContentId,
            "aria-expanded": open,
            onClick: handleShowMoreButtonClick,
            size: "inherit",
            variant: "grey",
            children: open ? "Less" : "More"
          })
        }), !!onCloseButtonClick && /* @__PURE__ */ jsx(TitleColumn, {
          children: /* @__PURE__ */ jsx(CloseButtonContainer, {
            children: /* @__PURE__ */ jsx(IconButton, {
              ...closeButtonProps,
              alignment: "iconEdges",
              "aria-label": "Close alert",
              background: "transparent",
              onClick: onCloseButtonClick,
              size: "tiny",
              styleParams: {
                size: internalCssVars.closeButtonSize
              },
              variant: "subdued",
              children: /* @__PURE__ */ jsx(SvgCross, {})
            })
          })
        })]
      }), !!children && !!title && /* @__PURE__ */ jsx(Content, {
        children
      }), !!showMoreContent && /* @__PURE__ */ jsx(Collapse, {
        "aria-hidden": !open,
        id: collapsedContentId,
        children: /* @__PURE__ */ jsx(ShowMoreContent, {
          children: /* @__PURE__ */ jsx(ShowMoreInner, {
            children: showMoreContent
          })
        })
      })]
    })]
  });
};
const Alert$1 = Alert;
export {
  Alert$1 as Alert
};
//# sourceMappingURL=index.js.map
